import Axios from "axios";
import { baseUrl, tokenHeader } from "../../router";

const state = () => ({
    servicecenter:undefined,
    servicecenters:undefined,
});

const getters = {
    allServiceCenter:(state)=>state.servicecenter,
    allServiceCenters:(state)=>state.servicecenters,
};

const actions = {
    async postServiceCenter({commit},data){
        try {
            let tkHeader = {};
            if (tokenHeader == undefined) {
                tkHeader = {
                    headers: {
                        "Authorization": `Bearer ${JSON.parse(localStorage.getItem("token")).token}`
                    }
                };
            }
            const response = await Axios.post(`${baseUrl}servicecenter/create`, data, tokenHeader != undefined ? tokenHeader : tkHeader);
            if (response.status == 201 || response.status == 200) {
                commit("setServiceCenter", response);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async getServiceCenterList({commit},data){
        try {
            let tkHeader = {};
            if (tokenHeader == undefined) {
                tkHeader = {
                    headers: {
                        "Authorization": `Bearer ${JSON.parse(localStorage.getItem("token")).token}`
                    }
                };
            }
            const response = await Axios.post(`${baseUrl}servicecenter/serviceCenterList`, data,tokenHeader != undefined ? tokenHeader : tkHeader);
            if (response.status == 200) {
                commit("setServiceCenters", response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async getSingleServiceCenter({commit},data){
        try {
            let tkHeader = {};
            if (tokenHeader == undefined) {
                tkHeader = {
                    headers: {
                        "Authorization": `Bearer ${JSON.parse(localStorage.getItem("token")).token}`
                    }
                };
            }
            const response = await Axios.get(`${baseUrl}servicecenter/singleServiceCenter/${data}`,tokenHeader != undefined ? tokenHeader : tkHeader);
            if (response.status == 200) {
                commit("setServiceCenter", response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async getServiceCenterFrontend({commit},data){
        try {
            const response = await Axios.post(`${baseUrl}servicecenter/serviceCenterFrontend`, data);
            if (response.status == 200) {
                commit("setServiceCenters", response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async deleteServiceCenter({ commit }, data) {
        try {
            let tkHeader = {};
            if (tokenHeader == undefined) {
                tkHeader = {
                    headers: {
                        "Authorization": `Bearer ${JSON.parse(localStorage.getItem("token")).token}`
                    }
                };
            }
            const response = await Axios.delete(`${baseUrl}servicecenter/singleServiceCenter/${data}`, tokenHeader != undefined ? tokenHeader : tkHeader);
            if (response.status == 200) {
                commit("setServiceCenters", response.data);
            }

        } catch (error) {
            console.log(error);
        }
    },
}

const mutations = {
    setServiceCenter: (state, data) => {
        return state.servicecenter = data;
    },
    setServiceCenters: (state, data) => {
        return state.servicecenters = data;
    },
};

export default { state, getters, actions, mutations };
